import { ShieldCheck } from "lucide-react";
import { Skeleton, SkeletonText, busyText } from "@/components/ui/skeleton";
import { useTranslation } from "@/hooks/useTranslation";

/**
 * SecondFactorPanel before its chunk is in — the panel's own first frame: the
 * shield tile with the heading beside it, then the code box (a label over the
 * six slots and the line under them). Sign-in and the step-up dialog used to
 * show SectionSkeleton here: a row of four figures over a list of six avatar
 * rows, inside a sign-in card, for a panel that has neither.
 */
export function SecondFactorSkeleton({ heading }: { heading?: { title: string; body: string } }) {
  const t = useTranslation();
  return (
    <div role="status" aria-busy="true" className="space-y-3.5" data-testid="second-factor-skeleton">
      <span className="sr-only">{busyText(t("shellSecurityLoadingSignInOptions", "Loading Sign-in Options"))}</span>
      <div aria-hidden="true" className="space-y-3.5">
        <div className="flex items-start gap-3">
          <span className="flex size-9 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary-ink">
            <ShieldCheck className="size-[18px]" />
          </span>
          <div className="min-w-0 flex-1">
            <h2 className="text-body font-semibold">{heading?.title ?? <SkeletonText className="w-40" />}</h2>
            <p className="mt-0.5 text-label text-muted-foreground">{heading?.body ?? <SkeletonText className="w-4/5" />}</p>
          </div>
        </div>
        <div className="space-y-3">
          <div className="block text-center text-label font-semibold"><SkeletonText className="w-40" /></div>
          <div className="flex w-full justify-center gap-1.5 sm:gap-2">
            {Array.from({ length: 6 }, (_, i) => (
              <Skeleton key={i} className="h-11 w-10 rounded sm:h-12 sm:w-11" />
            ))}
          </div>
          <p className="text-center text-label"><SkeletonText className="w-56 max-w-full" /></p>
        </div>
      </div>
    </div>
  );
}
